import { Classes, Intent, Button, IconNames } from "./externals";
import { ButtonWithDialog } from "./ButtonWithDialog";
import * as React from "react";
export function LockButton({ onClick, locked, hasInitialValues = true, showIcon = true, }) {
    const buttonText = locked ? "Cancel" : "Edit";
    const iconClass = locked
        ? Classes.iconClass(IconNames.CROSS)
        : Classes.iconClass(IconNames.EDIT);
    const buttonIntent = locked ? Intent.WARNING : Intent.NONE;
    let defaultButton = (React.createElement(Button, { intent: buttonIntent, type: "submit", className: `${Classes.BUTTON} ${showIcon ? iconClass : ""}`, onClick: onClick, text: buttonText, role: "lockButton" }));
    let dialogButton = (React.createElement(ButtonWithDialog, { form: () => "All changes will be lost", intent: buttonIntent, className: `${Classes.BUTTON} ${showIcon ? iconClass : ""}`, onAccept: onClick, text: buttonText }));
    return !locked
        ? defaultButton
        : !hasInitialValues
            ? dialogButton
            : defaultButton;
}
//# sourceMappingURL=LockButton.js.map